import { render, staticRenderFns } from "./AgroIcons.vue?vue&type=template&id=6ef5cbda&"
import script from "./AgroIcons.vue?vue&type=script&lang=js&"
export * from "./AgroIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports